import React from 'react'

import { styled } from '@driftt/dds'
import { Driftiwyg } from '@driftt/tide-driftiwyg'

import { usePersonalizationTokens } from 'hooks/usePersonalizationTokens'

import './style.css'

const TOOLBAR_CONFIG = [
  'bold',
  'italic',
  'underline',
  'numbered-list',
  'bulleted-list',
  'link',
  'emoji',
  'image',
  'tag',
]

const GenericLabel = styled('div', {
  marginBottom: '-12px',
})

interface MeetingDescriptionEditorProps {
  defaultDescription: string
  updateDescription: (state: string) => void
  readOnly: boolean
}

const MeetingDescriptionEditor = ({
  defaultDescription,
  updateDescription,
  readOnly,
}: MeetingDescriptionEditorProps) => {
  const { allTokens } = usePersonalizationTokens()

  const onChange = (val: string) => {
    const newDescription = val.replaceAll('<br/>', '<p></p>')
    updateDescription(newDescription)
  }
  if (allTokens) {
    return (
      <>
        <GenericLabel>Meeting description</GenericLabel>
        <Driftiwyg
          readOnly={readOnly}
          placeholder="Add what the goals of your meeting are and what your guest can expect..."
          editorState={defaultDescription ?? ''}
          onChange={onChange}
          toolbarOptions={TOOLBAR_CONFIG}
          autoFocus={false}
          meetingTagList={allTokens.guest}
          teammateTagList={allTokens.teammate}
          v2
        />
      </>
    )
  }
  return <></>
}

export default MeetingDescriptionEditor
